<template>
	<div>
		<h1>Profilom</h1>
		<v-simple-table>
			<tbody>
				<tr>
					<th style="text-align: right">Név</th>
					<td colspan="2" style="text-align: center">{{nev}}</td>
					<td>
						<!--<v-btn
							color="blue"
							@click="dialogus.megjelenik = true, dialogus.modositandoertek=0, dialogus.modositottertek=nev"
						>
							Módosítás<v-icon>fa-edit</v-icon>-->
						</v-btn>
					</td>
				</tr>
				<tr>
					<th style="text-align: right">Email</th>
					<td style="text-align: center">{{email}}</td>
					<td>
						<v-btn
							color="blue"
							@click="dialogus.megjelenik = true, dialogus.modositandoertek=1, dialogus.modositottertek=email"
						>
							Módosítás<v-icon>fa-edit</v-icon>
						</v-btn>
					</td>
				</tr>
				<tr>
					<th style="text-align: right">Minősítés</th>
					<td style="text-align: center">{{minositesnev}}</td>
					<td style="text-align: center">{{szilenciumvalasztas ? "Szilenciumválasztásra kötelezett" : "Szilenciumválasztás alól mentesült"}} - {{szilenciumiletszambaszamit ? "Tanulószobán tanul" : "Szobán tanul"}}</td>
				</tr>
				<tr v-if="csoportnev">
					<th style="text-align: right">Csoport</th>
					<td colspan="2" style="text-align: center">{{csoportnev}} - Csoportvezető: {{csoportvezeto}}</td>
				</tr>
				<tr v-if="szoba">
					<th style="text-align: right">Szoba</th>
					<td colspan="2" style="text-align: center">{{szoba}}</td>
				</tr>
				<tr>
					<th style="text-align: right">Jelszó</th>
					<td style="text-align: center">TITOK</td>
					<td>
						<v-btn
							color="blue"
							@click="dialogus.megjelenik = true, dialogus.modositandoertek=2, dialogus.modositottertek=''"
						>
							Módosítás<v-icon>fa-edit</v-icon>
						</v-btn>
					</td>
				</tr>
			</tbody>
		</v-simple-table>
		<h1>Információk</h1>
		<v-data-table v-if="informaciok"
			:headers="tablazatok.informaciok.fejlec"
			:items="informaciok"
			disable-pagination
			hide-default-footer>
			<template v-slot:item.informaciomerteke="{item}">
				{{item.informaciomerteke==0 ? "Teljes kollégium" : (item.informaciomerteke==1 ? "A csoportod" : (item.informaciomerteke==2 ? "A szobád" : 'Csak Te'))}}
			</template>

		</v-data-table>
		<h1 v-if="minosites>=0">Szakköreim</h1>
		<v-data-table
			v-if="minosites>=0"
			:headers="tablazatok.szakkorok.fejlec"
			:items="szakkorok"
			disable-pagination
			hide-default-footer
		>
			<template  v-slot:no-data>
				<v-icon large>fa-frown</v-icon><br/>
				<span>Ha nem akarod a kollégiumvezetőt és a csoportvezetődet magadra haragítani, válassz szakkört!</span>
			</template>
			<template v-slot:item.jelenlet9="{item}">
				<v-icon v-if="item.jelenlet9==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet10="{item}">
				<v-icon v-if="item.jelenlet10==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet11="{item}">
				<v-icon v-if="item.jelenlet11==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet12="{item}">
				<v-icon v-if="item.jelenlet12==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet1="{item}">
				<v-icon v-if="item.jelenlet1==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet2="{item}">
				<v-icon v-if="item.jelenlet2==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet3="{item}">
				<v-icon v-if="item.jelenlet3==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet4="{item}">
				<v-icon v-if="item.jelenlet4==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet5="{item}">
				<v-icon v-if="item.jelenlet5==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>
			<template v-slot:item.jelenlet6="{item}">
				<v-icon v-if="item.jelenlet6==1" color="success">fa-check</v-icon>
				<v-icon v-else color="red accent-4">fa-times</v-icon>
			</template>

		</v-data-table>
		<h1 v-if="szoba">Szobapontozás</h1>
		<v-data-table
			:headers="tablazatok.szobapontozas.fejlec"
			:items="[{a: 1}]"
			hide-default-footer
			v-if="szobapontozas.pontozas"
		>
			<template v-slot:item.hetfo="{item}">
				<v-chip color="success">
					Összeg: {{osszeg(hettetszolegesnapja(aktualishetfo(),0))}}
				</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in szobapontozas.pontozas.filter(p => p.nap==hettetszolegesnapja(aktualishetfo(),0)).map(p => {
					return {
						...p,
						...szobapontozas.szempontok.find(szp => szp.id==p.pontozasiszempontid)
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-on="on" v-bind="attrs" color="primary">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					<span>{{pont.leiras}} - {{pont.nevelo}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.kedd="{item}">
				<v-chip color="success">
					Összeg: {{osszeg(hettetszolegesnapja(aktualishetfo(),1))}}
				</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in szobapontozas.pontozas.filter(p => p.nap==hettetszolegesnapja(aktualishetfo(),1)).map(p => {
					return {
						...p,
						...szobapontozas.szempontok.find(szp => szp.id==p.pontozasiszempontid)
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-on="on" v-bind="attrs" color="primary">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					<span>{{pont.leiras}} - {{pont.nevelo}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.szerda="{item}">
				<v-chip color="success">
					Összeg: {{osszeg(hettetszolegesnapja(aktualishetfo(),2))}}
				</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in szobapontozas.pontozas.filter(p => p.nap==hettetszolegesnapja(aktualishetfo(),2)).map(p => {
					return {
						...p,
						...szobapontozas.szempontok.find(szp => szp.id==p.pontozasiszempontid)
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-on="on" v-bind="attrs" color="primary">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					<span>{{pont.leiras}} - {{pont.nevelo}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.csutortok="{item}">
				<v-chip color="success">
					Összeg: {{osszeg(hettetszolegesnapja(aktualishetfo(),3))}}
				</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in szobapontozas.pontozas.filter(p => p.nap==hettetszolegesnapja(aktualishetfo(),3)).map(p => {
					return {
						...p,
						...szobapontozas.szempontok.find(szp => szp.id==p.pontozasiszempontid)
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-on="on" v-bind="attrs" color="primary">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					<span>{{pont.leiras}} - {{pont.nevelo}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.pentek="{item}">
				<v-chip color="success">
					Összeg: {{osszeg(hettetszolegesnapja(aktualishetfo(),4))}}
				</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in szobapontozas.pontozas.filter(p => p.nap==hettetszolegesnapja(aktualishetfo(),4)).map(p => {
					return {
						...p,
						...szobapontozas.szempontok.find(szp => szp.id==p.pontozasiszempontid)
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-on="on" v-bind="attrs" color="primary">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					<span>{{pont.leiras}} - {{pont.nevelo}}</span>
				</v-tooltip>
			</template>
		</v-data-table>
		<template>
		  <v-row justify="center">
		    <v-dialog
		      v-model="dialogus.megjelenik"
		      persistent
		      max-width="600px"
		    >

		      <v-card>
		        <v-card-title>
		          <span class="headline">{{dialogus.modositandoertek ==0? "Név" : (dialogus.modositandoertek == 1 ? "Email-cím" : "Jelszó")}} módosítása</span>
		        </v-card-title>
		        <v-card-text>
		          <v-container>
		            <v-text-field
									v-model="dialogus.modositottertek"
									:label="dialogus.modositandoertek ==0? 'Név' : (dialogus.modositandoertek == 1 ? 'Email-cím' :  'Új jelszó')"
									:prepend-inner-icon="dialogus.modositandoertek ==0? 'fa-user' : (dialogus.modositandoertek == 1 ? 'fa-envelope' : 'fa-key')"
									:type="dialogus.modositandoertek==2 ? 'password' : 'text'">
								</v-text-field>
								<v-text-field v-model="dialogus.jelszo" type="password" prepend-inner-icon="fa-key" label="Régi jelszó"></v-text-field>
		          </v-container>
		        </v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn
		            color="blue darken-1"
		            text
		            @click="dialogus.megjelenik = false"
		          >
		            Mégsem
		          </v-btn>
		          <v-btn
		            color="blue darken-1"
		            text
		            @click="modositas()"
		          >
		            Módosítás
		          </v-btn>
		        </v-card-actions>
		      </v-card>
	    </v-dialog>
	  </v-row>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</template>
		<!--<v-row>
			<v-col>
				<v-text-field label="Név" v-model="nev"></v-text-field>
			</v-col>
			<v-col>
				<v-text-field label="Email" v-model="email"></v-text-field>
			</v-col>
			<v-col>
				<v-text-field label="Jelszó" type="password" autocomplete="off" v-model="jelszo"></v-text-field>
			</v-col>
			<v-col>
				<v-text-field label="Jelszó mégegyszer" type="password" autocomplete="off" v-model="jelszoismetles"></v-text-field>
			</v-col>
		</v-row>-->
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				nev: '',
				email: '',
				minositesnev: '',
				minosites: 0,
				csoportnev: '',
				csoportvezeto: '',
				szoba: '',
				szilenciumvalasztas: false,
				szilenciumiletszambaszamit: false,
				szakkorok: [],
				szobapontozas: {},
				informaciok: [],
				dialogus: {
					megjelenik: false,
					modositandoertek: 0,
					modositottertek: "",
					jelszo: ""
				},
				snackbar:{
	  			szoveg:"",
	  			megnyit:false
	  		},
				tablazatok: {
					informaciok: {
						fejlec: [
							{
								text: "Tárgy",
								value: "targy",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Információ",
								value: "informacio",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Címzett típusa",
								value: "informaciomerteke",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Feladó",
								value: "feladonev",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},

						]
					},
					szobapontozas: {
						fejlec: [
							{
								text: "Hétfő",
								value: "hetfo",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Kedd",
								value: "kedd",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Szerda",
								value: "szerda",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Csütörtök",
								value: "csutortok",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Péntek",
								value: "pentek",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							}
						]
					},
					szakkorok: {
						fejlec: [
							{
								text: "Szakkör",
								value: "szakkornev",
								align: "right",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Szakkörvezető",
								value: "nev",
								align: "right",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Időpontja és helye",
								value: "idoponteshely",
								align: "right",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "IX.",
								value: "jelenlet9",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "X.",
								value: "jelenlet10",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "XI.",
								value: "jelenlet11",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "XII.",
								value: "jelenlet12",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "I.",
								value: "jelenlet1",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "II.",
								value: "jelenlet2",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "III.",
								value: "jelenlet3",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "IV.",
								value: "jelenlet4",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "V.",
								value: "jelenlet5",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "VI.",
								value: "jelenlet6",
								align: "left",
								groupable: false,
								sortable: false,
								filterable: false
							},

						]
					}
				}
			}
		},
		computed: {

		},
		watch: {

		},
		methods: {
				modositas: function() {
					this.axios.post(this.$store.state.backendeleres+"profil",{modositandoertek: this.dialogus.modositandoertek, modositottertek: this.dialogus.modositottertek, jelszo: this.dialogus.jelszo})
										.then((response) => {
											this.snackbar.szoveg = response.data.ok ? "A módosítás sikeresen megtörtént." : "Hiba a módosítás során: "+response.data.hiba;
											this.snackbar.megnyit=true;
											if(response.data.ok) {
												if(this.dialogus.modositandoertek==0) this.nev=this.dialogus.modositottertek;
												else if(this.dialogus.modositandoertek==1) this.email=this.dialogus.modositottertek
												this.dialogus.megjelenik=false;
											}
										})
				},
				aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
				hettetszolegesnapja: function(hetfo, nap /*0: hétfő, 1: kedd*/)  {
					var datum = new Date(Date.parse(hetfo))
					datum.setDate(datum.getDate()+nap)
					return datum.toISOString().substring(0,10)
				},
				osszeg: function(nap) {
					var osszeg = this.szobapontozas.alapszobapont;
					this.szobapontozas.pontozas.filter(p => p.nap==nap).forEach(p => {
						osszeg+=this.szobapontozas.szempontok.find(szp => szp.id==p.pontozasiszempontid).pont
					})
					return osszeg;
				}
		},
		mounted(){
			this.axios.get(this.$store.state.backendeleres+"profil").then((response) => {
				if(response.data.ok){
					this.nev=response.data.nev;
					this.email=response.data.email;
					this.minositesnev=response.data.minositesnev;
					this.minosites=response.data.minosites;
					this.csoportnev = response.data.csoportnev;
					this.csoportvezeto=response.data.csoportvezeto;
					this.szoba=response.data.szobanev;
					this.szakkorok=response.data.szakkorok;
					this.szilenciumvalasztas=response.data.szilenciumvalasztas==1;
					this.szilenciumiletszambaszamit=response.data.szilenciumiletszambaszamit==1;
					this.szobapontozas=response.data.szobapontozas;
					this.informaciok=response.data.informaciok;
				}
				if(response.data.bejelentkezve==false) this.kijelentkezes();
			})
		}
	}
</script>
